import jQuery from "jquery";
import { ACTION, Events } from '../events'
import { VARS } from '../vars'

jQuery(document).ready(function($){
   let $header = $('.et-headerHolder')
   let $headerTopBar = $('.et-headerTopBar');
   var watchNavTimeout = undefined // needs to trigger

   let $topMenuMainContainer = $('.et-header nav');
   let $menuTopMenuItem = $topMenuMainContainer.find('li');
   let hasCurrentMenuItemSubmenu = $topMenuMainContainer.find('.current-menu-parent.menu-item-has-children').length == 0 && $topMenuMainContainer.find('.current-menu-item.menu-item-has-children').length == 0
 
   let setSubMenuState = function(isSubMenuEmpty) {
      if (isSubMenuEmpty) {
         $topMenuMainContainer.addClass('subMenuEmpty')
      } else {
         $topMenuMainContainer.removeClass('subMenuEmpty')
      }
   }

   let initListeners = function (){
      let $supportBarCompat = $(".et-header__supportBarInner.desktopCompact");
      let $phone = $supportBarCompat.find('.phone');
      let $mail = $supportBarCompat.find('.mail');
      $supportBarCompat.find('.phone').on("click", function(event){
         let $el = $(this);
         if ($el.hasClass('compact')) {
            $el.removeClass('compact');
            if (!$mail.hasClass('compact')) {
               $mail.addClass('compact')
            }
         }
         else {
            $el.addClass('compact');
         }
      });
      $supportBarCompat.find('.mail').on("click", function(event){
         let $el = $(this);
         if ($el.hasClass('compact')) {
            $el.removeClass('compact');
            if (!$phone.hasClass('compact')) {
               $phone.addClass('compact')
            }
         }
         else {
            $el.addClass('compact');
         }
      });
      $topMenuMainContainer.find(".menu > li").on("mouseenter", function(e){
         let $el = $(this);
         $el.addClass('highlight');
         $topMenuMainContainer.find(".menu > li").addClass('clear-hover');

         let isSubMenuEmpty = $(this).find('.sub-menu').length == 0

         setSubMenuState(isSubMenuEmpty)
      });
      $topMenuMainContainer.find(".menu > li").on("mouseleave", function(e){
         $topMenuMainContainer.find(".menu > li")
             .removeClass('clear-hover')
             .removeClass('highlight');

            setSubMenuState(hasCurrentMenuItemSubmenu)
      });
   }


   var setMenuClassName = function() {
      $('.single-research .menu-item-object-research').addClass('current-menu-parent')
   }

   var updateHeaderClass = function() {
      let yTrigger = 100

      if ($('body.home').length > 0) {
         yTrigger = 10
      }
      
      // pinned navi
      if (VARS.scrollTop > yTrigger) {
         $header.addClass('pinned')
         Events.emit(ACTION.MENU_PINNED_ACTIVE);
      } else {
         $header.removeClass('pinned')
         Events.emit(ACTION.MENU_PINNED_INACTIVE);
      }

      // compact navi

      if (VARS.scrollTop > yTrigger && VARS.W > 980) {
         $header.addClass('compact')
         $headerTopBar.addClass('compact')
         Events.emit(ACTION.MENU_COMPACT_ACTIVE)
      } else {
         Events.emit(ACTION.MENU_COMPACT_INACTIVE)
         $header.removeClass('compact')
         $headerTopBar.removeClass('compact')
      }
   }

   let onMobileTriggerClick = function() {
      VARS.mobileNavActive = !VARS.mobileNavActive
      
      if (VARS.mobileNavActive) {
         $header.addClass('active')
      } else {
         $header.removeClass('active')
      }
   }

   let onScroll = function() {

      updateHeaderClass()

      if (watchNavTimeout) {
         clearTimeout(watchNavTimeout)
         watchNavTimeout = setTimeout(() => {
               updateHeaderClass()
         }, 600)
      } else {
         watchNavTimeout = setTimeout(() => {
               updateHeaderClass()
         }, 300);
      }
   }

   let onResize = function() {
      setMenuMobileClassName()
   }

   let setEvents = function() {
      Events.on(ACTION.RESIZE, onResize)
      Events.on(ACTION.SCROLL, onScroll)
      Events.on(ACTION.CLICK_MOBILE_NAV_TRIGGER, onMobileTriggerClick)
      $menuTopMenuItem.on('mouseover', function () {
         let isSubMenuEmpty = $(this).find('.sub-menu').length == 0
   
         setSubMenuState(isSubMenuEmpty)
      })
   
      $menuTopMenuItem.on('mouseout', function () {
         setSubMenuState(hasCurrentMenuItemSubmenu)
      })

      $('.et-header__mobileTrigger').on('click', (e) => {
         e.preventDefault()
         Events.emit(ACTION.CLICK_MOBILE_NAV_TRIGGER)
      })

      $('.et-header__btnOpen').on('click', function() {
         let $form = $(this).closest('form');
         let searchQuery = $form.find('input[type="search"]').val()

         if (searchQuery.length > 0) {
            $form.submit()
         } else {
            $('.et-header__search').toggleClass('state-open');
         }
      })

      $header.find('li').each(function(index) {
         let $this = $(this)

         // let $link = $this.find('a').first()
         // $link.attr('data-url', $link.attr('href'))
         // $link.attr('href', '#')

         $this.removeClass('et-touch-hover et-show-dropdown et-hover')

         if ($this.find('.sub-menu').length > 0) {
            $this.addClass('menuItem-toggable')
         }
      })

      // $('.et-headerHolder .menuItem-toggable > a').on('click', function(e) { // delegate event
      //    let $this = $(this)
      //    let $thisParent = $this.parent()


      //    e.preventDefault()
      //    e.stopPropagation()
         
      //    $thisParent.find('.sub-menu').not('.active').removeClass('active')
      //    $thisParent.find('.sub-menu').first().toggleClass('active')

      //    if ($thisParent.hasClass('menuItem-toggable--open')) {
      //       $thisParent.removeClass('menuItem-toggable--open')
      //    } else {
      //       $thisParent.addClass('menuItem-toggable--open')
      //    }
         
      //    // return true // touch event fix
      // })

      $('body').on('click', '.et-headerHolder--mobile .menuItem-toggable > a', function(e) { // delegate event
         let $this = $(this)
         let $thisParent = $this.parent()
         
         e.preventDefault()
         e.stopPropagation()
         
         $thisParent.find('.sub-menu').not('.active').removeClass('active')
         $thisParent.find('.sub-menu').first().toggleClass('active')

         if ($thisParent.hasClass('menuItem-toggable--open')) {
            $thisParent.removeClass('menuItem-toggable--open')
         } else {
            $thisParent.addClass('menuItem-toggable--open')
         }
         
         return true // touch event fix
      })
   }

   let updateSubNavPos = function() {

      var isMobile = window.innerWidth <= 980

      $('#menu-top-menu > li').each(function(index, item) {
         let $this = $(this)
         let $subMenu = $this.find('.sub-menu').first()
         var moveLeft = 0

         if ($subMenu.length > 0) {
            moveLeft = ($subMenu.offset().left).toFixed(0);
            $subMenu.css('margin-left', isMobile ? 0 : -moveLeft)
         }
      })
   }

   let setMenuMobileClassName = function() {
      if (window.innerWidth > 979) {
         $header.removeClass('et-headerHolder--mobile')
      } else {
         $header.addClass('et-headerHolder--mobile')
      }
   }

   let cloneMenuAndAdd = function() {
      let $clone = $('.et-header__container').html()
      $('.et-header__container').remove()
      $('.et-header__nav').append($clone)
   }
   
   let init = function() {
      window.et_pb_toggle_nav_menu = function() {
         // clear divi events for nav
      }
      window.et_pb_init_nav_menu = function() {
         // clear divi events for nav
      }
      cloneMenuAndAdd() // remove divi events
      setMenuMobileClassName()
      setEvents()
      setMenuClassName()
      initListeners()
      setTimeout(() => {
         updateSubNavPos()
         updateHeaderClass()
      }, 1000);
   }

   // $topMenuMainContainer.append('<div class="ex-top-menu-submenu"></div>');

   init()
 });